import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------
const CONFIG_MAP = {
  Development: {
    serverUrl: 'https://backoffice.ncp-dev.com',
    assetURL: 'https://backoffice.ncp-dev.com/backoffice',
  },
  Testing: {
    serverUrl: 'https://backoffice.ncp-test.com',
    assetURL: 'https://backoffice.ncp-test.com/backoffice',
  },
  Production: {
    serverUrl: 'https://backoffice.ncp-sys.com',
    assetURL: 'https://backoffice.ncp-sys.com/backoffice',
  },
  Load: {
    serverUrl: 'https://backoffice.ncp-load.com',
  },
  WAProduction: {
    serverUrl: 'https://backoffice.ncp.watechnology.com',
  }
};
const ENV = process.env.REACT_APP_ENVIRONMENT || 'Development';

const ENV_SHORT = {
  Development: 'DEV',
  Testing: 'TEST',
  Production: 'PROD',
  Load: 'LOAD',
  WAProduction: 'WAPROD',
};

export const CONFIG = {
  site: {
    name: 'Axion',
    environment: ENV,
    // Browser tab title, e.g. "NCP Admin - TEST"
    title: `NCP Admin - ${ENV_SHORT[ENV] ?? ENV}`,
    ...CONFIG_MAP[ENV],
    basePath: process.env.REACT_APP_BASE_PATH ?? '',
    version: packageJson.version,
  },
  /**
   * Auth
   * @method jwt | amplify | firebase | supabase | auth0
   */
  auth: {
    method: 'jwt',
    skip: false,
    redirectPath: paths.dashboard.gameConfiguration.list,
  },
  /**
   * Mapbox
   */
  mapbox: {
    apiKey: process.env.REACT_APP_MAPBOX_API_KEY ?? '',
  },
};
